import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as NotificationActions from './notification.actions';
import { NotificationEntity } from './notification.models';

export const NOTIFICATIONS_FEATURE_KEY = 'notifications';

export interface State extends EntityState<NotificationEntity> {
  loading: boolean;
  error?: string | null;
}

export interface NotificationPartialState {
  readonly [NOTIFICATIONS_FEATURE_KEY]: State;
}

export function selectNotificationId(notification: NotificationEntity): string {
  return notification._id;
}

export const notificationAdapter: EntityAdapter<NotificationEntity> = createEntityAdapter<NotificationEntity>(
  {
    selectId: selectNotificationId
  }
);

export const initialState: State = notificationAdapter.getInitialState({
  loading: false
});

const notificationReducer = createReducer(
  initialState,
  on(NotificationActions.loadNotifications, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(NotificationActions.loadNotificationsSuccess, (state, { notifications }) =>
    notificationAdapter.setAll(notifications, { ...state, loading: false })
  ),
  on(NotificationActions.dismissAllSuccess, (state, {}) =>
    notificationAdapter.removeAll(state)
  ),
  on(NotificationActions.dismissSingleSuccess, (state, { notificationId }) =>
    notificationAdapter.removeOne(notificationId, state)
  ),
  on(NotificationActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),
  on(NotificationActions.dismissSingleFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),
  on(NotificationActions.dismissAllFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return notificationReducer(state, action);
}
